import './App.css';
import { React, useState, useEffect } from 'react';
import { ethers } from 'ethers';
import toast, { Toaster } from 'react-hot-toast';

import Button from '@mui/joy/Button';
import Input from '@mui/joy/Input';
import Grid from '@mui/joy/Grid';
import FormControl from '@mui/joy/FormControl';
import Select from '@mui/joy/Select';
import Option from '@mui/joy/Option';
import Tooltip from '@mui/joy/Tooltip';
//import { Container } from '@mui/joy';

import { HeaderBlock } from './Components/headerBlock';
import CurrencySelector from './Components/currencySelector';
import { FaucetButton } from './Components/faucetButton';
import { contractAddress, underlyingUSDC, USDCaddress, contractWithSigner, comet, SEPOLIA_CHAIN_ID } from './Config/configUSDC';
import { redeemData } from './Helpers/redeemData';
// const MMSDK = new MetaMaskSDK();
// await MMSDK.init();
//const provider = await detectEthereumProvider();
// const ethereum = MMSDK.getProvider(); // You can also access via window.ethereum
if(window.ethereum) {
  window.ethereum.on('chainChanged', () => {
    window.location.reload();
  })
  window.ethereum.on('accountsChanged', () => {
    window.location.reload();
  });
}

async function switchChain() {

  await window.ethereum.request({
    method: 'wallet_switchEthereumChain',
    params: [{ chainId: SEPOLIA_CHAIN_ID }],
  });

}

function Payment() {
  const [account, setAccount] = useState(null);
  const [amount, setAmount] = useState("");
  const [dueDate, setDueDate] = useState("");
  const [supplierAddress, setSupplierAddress] = useState("");
  const [feeAddress, setFeeAddress] = useState("");
  const [feeAmount, setFeeAmount] = useState("");
  const [paymentReference, setPaymentReference] = useState("");
  const [allowance, setAllowance] = useState(null);
  const [allowanceAmountTest, setAllowanceAmountTest] = useState({amount: 0});
  const [invoicePaid, setInvoicePaid] = useState(false);
  const [requestNetworkPayment, setRequestNetworkPayment] = useState();
  const [amountErrorPresent, setAmountErrorPresent] = useState(false);
  const [feeAmountErrorPresent, setFeeAmountErrorPresent] = useState(false);

  let tempAccount;
  const getAccount = async() => {
    tempAccount = await window.ethereum.request({ method: 'eth_requestAccounts', params: [] });
    setAccount(tempAccount[0]);
  }

  const getAccountWithClick = async() => {
    tempAccount = await window.ethereum.request({ method: 'eth_requestAccounts', params: [] });
    setAccount(tempAccount[0]);
    switchChain();
  }

  const ConnectedWallet = ({account}) => {
    if (account) {
      let accountString = account.toString()
      let accountLength = accountString.length;
      let slicedAccount = account.slice(0, 4) + "..." +  account.slice(accountLength -4, accountLength);
      return (
        <div className="connectedWallet">
          {slicedAccount} <br />
          connected
        </div>
        )
    } else {
        return (
          <div className="connectButton">
            <Button onClick={getAccountWithClick}>Connect wallet</Button>
          </div>
        )
    }
  }

  const checkConnection = async() => {
    let getConnectionStatus = await window.ethereum.request({ method: 'eth_accounts' });
    if(getConnectionStatus.length > 0) {
      getAccount();
    }
  }
  
  useEffect(() => {
    checkConnection();
    
      
    // eslint-disable-next-line react-hooks/exhaustive-deps
  });

  useEffect(() => {

    let needToFetchAllowance = true;
    getAllowance().then(data => {
      if (needToFetchAllowance) setAllowance(data);

    });
    return () => { needToFetchAllowance = false }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [allowanceAmountTest]);

  const handleUpdatePayment = () => setInvoicePaid(true);

  const handleChangeAmount = event => {
    setAmount(event.target.value);
    switchChain();
    getAllowance();
  };

  const handleChangeDueDate = event => {
    let dueDateEpoch = new Date(event.target.value).valueOf() / 1000;
    setDueDate(dueDateEpoch);
  }

  const handleChangeSupplierAddress = event => {
    setSupplierAddress(event.target.value);
  };

  const handleChangeFeeAddress = event => {
    setFeeAddress(event.target.value);
  };

  const handleChangeFeeAmount = event => {    
    setFeeAmount(event.target.value);
    switchChain();
    getAllowance();
  };

  const handleChangePaymentReference = event => {
    setPaymentReference(event.target.value);
  };

  const handleBlurAmount = event => {
    let input = event.target.value;
    const validatedInput = input.match(/^(\d*\.{0,1}\d{0,6}$)/);
    setAmountErrorPresent(false);
    
    if(!validatedInput) {
      alert("Only 6 decimals and/or positive numbers allowed");
      setAmountErrorPresent(true);
    }
  }

  const handleBlurFeeAmount = event => {
    let input = event.target.value;
    const validatedInput = input.match(/^(\d*\.{0,1}\d{0,6}$)/);
    setFeeAmountErrorPresent(false);
    
    if(!validatedInput) {
      alert("Only 6 decimals and/or positive numbers allowed");
      setFeeAmountErrorPresent(true);
    }
  }

  async function getAllowance() {
    let accountAllowance = await underlyingUSDC.allowance(account, contractAddress);
    setAllowance(accountAllowance);
    return accountAllowance;
  }

  async function toastIncreaseAllowance() {
    const toastPromiseAllowance = approveContract();
    const allowancePromise = new Promise((resolve, reject) => 
    
      toast.promise(toastPromiseAllowance, {
        loading: 'Increasing allowance, hold on',
        success: 'Your allowance was increased, well done!',
        error: (err) => `Error: ${err.toString()}`,
      },
        {
          style: {
            minWidth: '250px',
            width: '500px',
          },
          className: 'toastPayInvoices',

        }
      )
    )
    await toastPromiseAllowance;
    allowancePromise.then(console.log("Allowance increased"));
  }

  async function toastPayInvoice() {
    const toastPromise = supplyAndPayUSDC();
    const paymentPromise = new Promise((resolve, reject) => 
    
      toast.promise(toastPromise, {
        loading: 'Paying your invoice, hold on',
        success: 'Your invoice was paid, well done!',
        error: (err) => `Error: ${err.toString()}`,
      },
        {
          style: {
            minWidth: '250px',
            width: '500px',
          },
          className: 'toastPayInvoices',

        }
      )
    )
    await toastPromise;
    paymentPromise.then(handleUpdatePayment());
    
  }

  async function supplyAndPayUSDC() {
    switchChain();
    let amountToPay = ethers.utils.parseUnits(amount, 6);
    let feeAmountToPay = ethers.utils.parseUnits(feeAmount, 6);
    let paymentReferenceBytes = ethers.utils.toUtf8Bytes(paymentReference);
    let transferERC20 = await contractWithSigner.payInvoiceERC20(
      supplierAddress,
      feeAddress,
      dueDate,
      amountToPay,
      feeAmountToPay,
      paymentReferenceBytes,
      requestNetworkPayment
    )
    await transferERC20.wait();
    setAmount("");
    setFeeAmount("");
    setDueDate("");
    setFeeAddress("");
    setSupplierAddress("");
    setRequestNetworkPayment("");
    setPaymentReference("");
    getAllowance();
    //let receipt = await provider.getTransactionReceipt(transferERC20.hash);
  }

  function createMinDueDate() {
    let nowEpoch = Date.now();
    var minDueDate = Number(86400*8*1000);
    var dueDateToPass = Math.round(Number(minDueDate + nowEpoch));

    let d = new Date(dueDateToPass);
    let currentYear = d.getFullYear();
    let currentMonth;
    let currentMonthTemp = d.getMonth();
    if(currentMonthTemp < 10) {
      currentMonth = "0" + (Number(currentMonthTemp + 1)); //zero indexed
    } else {
      currentMonth = (Number(currentMonthTemp + 1)); //zero indexed
    }
    let currentDate;
    let currentDateTemp = d.getDate();
    if(currentDateTemp < 10) {
      currentDate = "0" + currentDateTemp;
    } else {
      currentDate = currentDateTemp;
    }
    let currentDateFormatted = currentYear + "-" + currentMonth + "-" + currentDate;
    return currentDateFormatted;    
  }

  function createMaxDueDate() {
    let nowEpoch = Date.now();
    var minDueDate = Number(86400*14*1000);
    var dueDateToPass = Math.round(Number(minDueDate + nowEpoch));

    let d = new Date(dueDateToPass);
    let currentYear = d.getFullYear();
    let currentMonth;
    let currentMonthTemp = d.getMonth();
    if(currentMonthTemp < 10) {
      currentMonth = "0" + (Number(currentMonthTemp + 1)); //zero indexed
    } else {
      currentMonth = (Number(currentMonthTemp + 1)); //zero indexed
    }
    let currentDate;
    let currentDateTemp = d.getDate();
    if(currentDateTemp < 10) {
      currentDate = "0" + currentDateTemp;
    } else {
      currentDate = currentDateTemp;
    }

    let currentDateFormatted = currentYear + "-" + currentMonth + "-" + currentDate;
    return currentDateFormatted;    
  }

  async function approveContract() {
    let amountNumber = Number(amount);
    let feeAmountNumber = Number(feeAmount);
    let minimumToApprove = amountNumber + feeAmountNumber;
    switchChain();
    let tempAmountToApprove = minimumToApprove.toString();
    let amountToApprove = ethers.utils.parseUnits(tempAmountToApprove, 6);

    let approve = await underlyingUSDC.approve(contractAddress, amountToApprove);
    await approve.wait();
    setAllowanceAmountTest({...allowanceAmountTest, amount: amount});
    console.log("Approved ",amountToApprove);
  }

  async function logSupplyRate() {
    const supplyRate = await comet.callStatic.getSupplyRate(0.8e16);
    console.log(supplyRate);
  }

  const PaymentButton = ({account, amount, dueDate, supplierAddress, feeAddress, feeAmount, paymentReference, underlyingUSDC, contractAddress}) => {
    let amountNumber = Number(amount);
    let feeAmountNumber = Number(feeAmount);
    let minimumToApprove = amountNumber + feeAmountNumber;
    let allowanceNumber = Number(allowance / 10**6);

    if (account && amount && dueDate && supplierAddress && feeAddress && feeAmount && paymentReference && allowanceNumber >= minimumToApprove && !invoicePaid && requestNetworkPayment != null && amountErrorPresent === false && feeAmountErrorPresent === false) {
      return (
        <div className="paymentButton">
            <Button type="submit" size="sm" onClick={toastPayInvoice}>Pay and earn</Button>
        </div>
      )
    }
    else if (account && amount && dueDate && supplierAddress && feeAddress && feeAmount && paymentReference && allowanceNumber < minimumToApprove && requestNetworkPayment != null && amountErrorPresent === false && feeAmountErrorPresent === false) {
      return (
          <div className="paymentButton">
              <Button type="submit" onClick={toastIncreaseAllowance}>Increase allowance</Button>
          </div>
      ) 
    } else if(amountErrorPresent === true) {
      return (
        <div className="paymentButtonNotConnected">
          Please input a correct amount (6 decimals max.)
        </div>
      )
    } else if(feeAmountErrorPresent === true) {
      return (
        <div className="paymentButtonNotConnected">
          Please input a correct fee amount (6 decimals max.)
        </div>
      )
    } else {
      return (
        <div className="paymentButtonNotConnected">
          Please complete all fields
        </div>
      ) 
    }  
  } 
  
  return (
    <Grid container sx={{ flexGrow: 1 }} className="App-header">
      <Grid xs={1}>
        <FaucetButton USDCaddress={USDCaddress} />
      </Grid>
      <Grid xs={10}>
        <HeaderBlock />
      </Grid>
      <Grid xs={1}>
        <ConnectedWallet account={account} getAccount={getAccount} />
      </Grid>
      <Grid xs={5}>
      </Grid>
      <Grid xs={2}>        
        <form onSubmit={(event) => {event.preventDefault();}}>
          <label>Currency</label>           
          <CurrencySelector /><br />
          <label>Amount</label> 
          <Input type="text" value={amount} className="input-number" onChange={handleChangeAmount} onBlur={handleBlurAmount} required />
          <FormControl>
            <label>Due date</label>
            <Input type="date" slotProps={{
              input: {
                min: createMinDueDate(),
                max: createMaxDueDate(),
              },
            }} className="input-number" onChange={handleChangeDueDate} onKeyDown={(e) => e.preventDefault()} required />
          </FormControl>
          <label>Supplier address</label>
          <Input type="text" className="input-supplier" onChange={handleChangeSupplierAddress} required />
          <label>Fee amount</label>
          <Tooltip title="This amount will be added as an extra fee. When the payment reference is paid out, the fee address will receive the fee." variant="solid">
            <Input type="text" value={feeAmount} className="input-feeAmount" onChange={handleChangeFeeAmount} onBlur={handleBlurFeeAmount} required />
          </Tooltip>
          <label>Fee address</label>
          <Input type="text" className="input-feeAddress" onChange={handleChangeFeeAddress} required />         
          <label>Payment reference</label> 
          <Input type="text" className="input-reference" onChange={handleChangePaymentReference} required />
          <label>Payment through Request Network</label>
          <Tooltip title="Set to yes if you want your payment reference to be compatible with Request Network. For more information, visit https://www.request.network/." variant="solid">
            <Select value={requestNetworkPayment} className="input-requestNetwork" onChange={(e, newValue) => setRequestNetworkPayment(newValue)} required>
              <Option value={"0"}>No</Option>
              <Option value={"1"}>Yes</Option>
            </Select>
          </Tooltip>
          <PaymentButton
            account={account}
            amount={amount}
            dueDate={dueDate}
            supplierAddress={supplierAddress}
            feeAddress={feeAddress}
            feeAmount={feeAmount}
            paymentReference={paymentReference}
            contractWithSigner={contractWithSigner}
            underlyingUSDC={underlyingUSDC}
            contractAddress={contractAddress}
            invoicePaid={invoicePaid}      
            requestNetworkPayment={requestNetworkPayment}
            amountErrorPresent={amountErrorPresent}
            feeAmountErrorPresent={feeAmountErrorPresent}
          />
          <Toaster
          toastOptions={{
            success: {
              duration: 6000,
              icon: '🔥',
            },
          }} />
      </form>
      </Grid>
      <Grid xs={5}>
        {/* <button onClick={redeemData}>Redeem logging</button><br />
        <button onClick={logSupplyRate}>log supply rate</button> */}
      </Grid> 
    </Grid>
  );
}

export default Payment;

